cb.define([], function () {
	var PC_pc_presentationclass_VM_Extend = {
		doAction: function (name, viewmodel) {
		  if (this[name]) {
		    this[name](viewmodel);
		  }
		},
		init: function (viewmodel) {
      let valModel = viewmodel.get('manageClass_Name');
		 valModel && valModel.on('beforeValueChange', ({value}) => {
			
			if (value) {
				if (!value.isEnd) {
					cb.utils.alert('请选择末级节点', 'warning');
					return value.isEnd
				}
			}
		})
		
		viewmodel.on('afterLoadData', (args) => {
        let showInFront = viewmodel.getParams().carryParams.showInFront;
		let iUOrderStatus = viewmodel.getParams().carryParams.iUOrderStatus;
        if(showInFront!=undefined && !showInFront ){
          viewmodel.get('showInFront').setValue('false');
		  viewmodel.get('showInFront').setDisabled(true);
        }
		
        if(iUOrderStatus!=undefined  && !iUOrderStatus) {
          viewmodel.get('iUOrderStatus').setValue('false');
		  viewmodel.get('iUOrderStatus').setDisabled(true);
        }
      })

	 },
	}
  try {
    module.exports = PC_pc_presentationclass_VM_Extend;
  } catch (error) {
  	// 当 类型 为 档案 的时候
  }
  return PC_pc_presentationclass_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_presentationclass_VM.Extend.js